import { render } from "./PerfilPassword.vue?vue&type=template&id=56525ff2"
import script from "./PerfilPassword.vue?vue&type=script&lang=ts"
export * from "./PerfilPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script